import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ls from "local-storage";
import ProgressBar from "react-bootstrap/ProgressBar";
import * as CONFIG from "./_config";

import "react-step-progress-bar/styles.css";
import { ProgressBar as ProgressBarnew, Step } from "react-step-progress-bar";
import { Form } from "react-bootstrap";
import RewardDetailsModal from "./rewarddetails";
import PunchRewardDetailsModal from "./punchrewarddetails";
import ViewHistoryModal from "./ViewHistoryModal";

toast.configure();
const axios = require("axios");

const Loader = () => (
  <div className="ring">
    Loading
    <span className="span1"></span>
  </div>
);

class Myrewards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      myrewards: null,
      reedemoptions: null,
      selectValue: null,
      loading: false,
      buttonVisible: true,
      modalOpen: false,
      modalOpenSelectedValue: null,
    };
  }

  openModal = (item) => {
    this.setState({
      modalOpen: true,
      modalOpenSelectedValue: item,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Myrewardslist();
    }
    ls.set("redirectTo", window.location.href);
  }

  componentDidMount() {
    this.Myrewardslist();
    ls.set("redirectTo", window.location.href);
  }


  Myrewardslist() {
    const data = new FormData();

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    data.append("method", "POST");
    // set user id
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetLMRewards/${UserToken}`);
    // const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetLMRewards/${UserToken}`;
    let apiurl = "";
    if (CONFIG.DATA.ALLOW_POINT_BASE_REWARD_API) {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetLMRewardsV2/${UserToken}`;
    } else {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetLMRewards/${UserToken}`;
    }
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.LMRewards) {
          this.setState({ myrewards: res.data.LMRewards, loading: false });
        } else {
          this.setState({ myrewards: [] });
        }
      })
      .catch(function (response) {
        this.setState({ myrewards: [] });
        console.log(response);
      });
  }

  showLoader = () => {
    this.setState({ loading: true });
  };

  hideLoader = () => {
    this.setState({ loading: false });
  };

  getNext = (ev) => {
    ev.preventDefault();

    this.showLoader();

    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    var MemberNumber = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
      : "";
    var LMRewardId = this.state.myrewards
      ? this.state.myrewards[0].LMRewardId
      : "";

    //data.append('method', 'GET');
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetQualifiedRewardTiers/${UserToken}/${MemberNumber}/${LMRewardId}`);

    let apiurl = "";
    if (CONFIG.DATA.ALLOW_POINT_BASE_REWARD_API) {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetQualifiedRewardTiersV2/${UserToken}/${MemberNumber}/${LMRewardId}`;
    } else {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetQualifiedRewardTiers/${UserToken}/${MemberNumber}/${LMRewardId}`;
    }

    // var object = {};
    // data.forEach((value, key) => (object[key] = value));
    // var jsonData = JSON.stringify(object);

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('res',res.data.QualifiedRewardTiers);
        this.hideLoader();
        if (res.data.QualifiedRewardTiers) {
          this.setState({
            reedemoptions: res.data.QualifiedRewardTiers,
            buttonVisible: false,
            rewardDetailsResponse: res.data.RewardDetails,
          });
        } else {
          this.setState({ reedemoptions: [] });
        }
      })
      .catch(function (response) {
        this.setState({ reedemoptions: [] });
        console.log(response);
      });
  };

  onFormSubmit(ev) {
    ev.preventDefault();

    var value = this.state.selectValue;
    //alert(value);

    const answer = window.confirm(
      "Are you sure to reedem $" + value + " value coupon?"
    );

    if (answer) {
      this.showLoader();

      // Save it!
      var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
        : "";
      var MemberNumber = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
        : "";

      const data = new FormData();
      const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/CreatePointsBasedRewardCouponForMemberNumber`;
      data.append("method", "POST");
      //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/CreatePointsBasedRewardCouponForMemberNumber`);
      data.append("MemberNumber", MemberNumber);
      data.append("CouponValue", value);
      data.append("RewardID", this.state?.rewardDetailsResponse?.LMRewardID);
      data.append("TierID", this.state?.selectedRewardDataToRedeem?.LMRewardTierID);
      data.append("UserToken", UserToken);

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })

        .then((res) => {
          if (res.data.CouponId == 0) {
            this.hideLoader();
            toast.success("Your Coupon Code is reedem successfully", {
              autoClose: 2000,
            });

            setTimeout(function () {
              window.location.reload();
            }, 2200);
          }
        })
        .catch(function (res) {
          toast.error("Error Notification !");
        });
    } else {
      // Do nothing!
      this.hideLoader();

      console.log("Thing was not saved.");
    }

    // console.log(this.state.selectValue)
  }

  onlyOne(e) {
    var id = e.target.id;
    var eventCheckbox = document.getElementById(id);
    var checkboxes = document.getElementsByName("redeemCheck");

    checkboxes.forEach((item) => {
      // console.log(item, eventCheckbox);
      if (item !== eventCheckbox) item.checked = false;
    });
    let selectedReward = this.state?.reedemoptions[id];
    // console.log(selectedReward);
    // console.log(e.target.id, e.target.checked);
    if (e.target.checked)
      this.setState({
        selectValue: e.target.value,
        selectedRewardDataToRedeem: selectedReward,
      });
    else
      this.setState({
        selectValue: null,
        selectedRewardDataToRedeem: null,
      });
  }

  onChangeCoupon(e) {
    this.setState({ selectValue: e.target.value });
  }

  Loopcount(buy, parchaes) {
    var count = [];

    for (var i = 1; i <= parchaes; i++) {
      count.push({ color: "#e9967a" });
    }
    for (var j = 1; j <= buy - parchaes; j++) {
      count.push({ color: "" });
    }
    return count;
  }

  pointloop(a, r) {
    const arr1 = [];
    var quotient = Math.round(Math.floor(a / r));

    for (var k = 0; k <= quotient; k++) {
      var quotient1 = Math.round(Math.floor(a / r));
      arr1.push({ point: k });
    }
    return arr1;
  }


  ViewItemsAPI() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    var lmRewardTierId = this.state?.selectedRewardDataToRedeem?.LMRewardTierID;
    var lmRewardId = this.state?.rewardDetailsResponse?.LMRewardID;

    let selectedReward =
      this.state?.reedemoptions[this.state?.SeletedRewardIndex];

    let apiUrl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetUPCTierProducts/${UserToken}/${lmRewardId}/${lmRewardTierId}`;
    // let apiUrl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetUPCTierProducts/84365460-7799-4698-9AA1-DFB01BD29C28/${lmRewardId}/${lmRewardTierId}`;

    axios
      .get(apiUrl, {
        // headers: { domainname: "qaecrs" }
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((response) => {
        this.setState({ RewardTierProducts: response.data.RewardTierProducts });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getHistory = (e) => {
    e.preventDefault();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    let apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ViewPointsExpiryHistory/${UserToken}`;
    axios
      .get(apiurl, { headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN } })
      .then((res) => {
        this.setState({ historyData: res.data });
      })
      .catch((error) => {
        this.setState({ historyData: error?.response?.data });
      });
  };


  render() {

    let qualifiedForRewardsLength = this.state?.reedemoptions?.filter(
      (each) => each.IsItQualifiedforReward === true
    ).length;

    return (
      <div>
        {this.state.loading ? <Loader /> : null}

        <div className="main-container full-width mt-2 pt-2">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">My Rewards</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href={CONFIG.DATA.BASEPATH}>Home</a>
                        </li>
                        <li>
                          <span>My account</span>
                        </li>
                        <li>
                          <span className="active">My Rewards</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">My Rewards</h1>
                  </header>
                  <div className="breadcrumbs">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> My Rewards</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="page-content">
            <div className="container">
              <article
                id="post-22"
                className="post-22 page type-page status-publish hentry"
              >
                {CONFIG.DATA.ALLOW_POINT_BASE_REWARD_API && (
                  <div
                    className="modal fade bd-example-modal-lg"
                    id="redeemPointsModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="redeemPointsModal"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-lg" role="document">
                      <div className="modal-content">
                        <div className="modal-header model-header-main" style={{ backgroundColor: "#f4f4f4" }}>
                          <h5
                            className="modal-title model-title-wrap"
                            id="redeemPointsModal"
                          >
                            <div className="model-points">
                              LOYALTY REWARD AVAILABLE:{" "}
                            </div>
                            <div className="model-blance">
                              {
                                this.state?.rewardDetailsResponse
                                  ?.MemberPointsString
                              }{" "}
                              {"(" +
                                this.state?.rewardDetailsResponse
                                  ?.RewardPointsText +
                                ")"}
                            </div>
                          </h5>

                          <button
                            type="button"
                            className="close close-btn"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <Form
                          onSubmit={this.onFormSubmit.bind(this)}
                          role="form"
                        >
                          <div
                            className="modal-body"
                            style={{
                              overflow: "auto",
                              maxHeight: "25rem",
                            }}
                          >
                            <div className="" style={{ textAlign: "left" }}>
                              <span
                                style={{
                                  fontSize: "1rem",
                                }}
                              >
                                {
                                  this.state?.rewardDetailsResponse
                                    ?.RewardOptionsNoteText
                                }
                              </span>
                              <br />
                              <span>
                                {
                                  this.state?.rewardDetailsResponse
                                    ?.RewardOptionsText
                                }
                              </span>
                              {this.state?.reedemoptions?.map((each, i) => {
                                return (
                                  <div
                                    className="form-check form-main-wrap form-item-view"
                                    style={{
                                      marginLeft: "1rem",
                                      textAlign: "left",
                                      marginTop: "0.5rem",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    <div className="form-wrap-detail">
                                      {/* <hr /> */}
                                      {each?.IsItQualifiedforReward && (
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="redeemCheck"
                                          value={each.CouponValue}
                                          id={`${i}`}
                                          onChange={this.onlyOne.bind(this)}
                                        />
                                      )}

                                      <img
                                        src={each.TierImageUrl}
                                        alt=""
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        for={`flexCheck${i}`}
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "0.5rem",
                                        }}
                                      >
                                        {each.PointsRequiredString}
                                      </label>
                                      <label
                                        className="form-check-label"
                                        for={`flexCheck${i}`}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <span style={{ paddingLeft: "2rem" }}>
                                          {each.TierTitle}
                                        </span>
                                      </label>
                                    </div>
                                    <div className="reward-btn-main">
                                      {each.TierRewardCouponTypeId === 2 && (
                                        <span
                                          className="btn btn-warning reword-item-btn cardenasmarkets-btn"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onMouseDown={() => {
                                            this.setState({
                                              selectedRewardDataToRedeem:
                                                this.state?.reedemoptions[i],
                                            });
                                          }}
                                          onClick={this.ViewItemsAPI.bind(this)}
                                          data-toggle="modal"
                                          data-target="#redeemPointDetailsModal"
                                        >
                                          View Items
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="modal-footer">
                            <div style={{ color: "red", fontSize: "0.8rem" }}>
                              <span>
                                * Only one reward can be applied at a time.
                                Select one and click Redeem.
                              </span>
                            </div>

                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={
                                qualifiedForRewardsLength === 0 ||
                                this.state?.selectedRewardDataToRedeem === null
                              }
                            >
                              REDEEM
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                )}
                {CONFIG.DATA.ALLOW_POINT_BASE_REWARD_API && (
                  <div
                    className="modal fade"
                    id="redeemPointDetailsModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="redeemPointDetailsModal"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-lg" role="document">
                      <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: "#f4f4f4" }}>
                          <h5 className="modal-title" id="redeemPointsModal">
                            Reward Details
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div
                          className="modal-body"
                          style={{
                            overflow: "auto",
                            maxHeight: "25rem",
                          }}
                        >
                          <img
                            src={
                              this.state?.selectedRewardDataToRedeem
                                ?.TierImageUrl
                            }
                            alt=""
                            style={{ height: "5rem", width: "5rem" }}
                          />
                          {this.state?.RewardTierProducts && (
                            <>
                              <h5 className="mt-5">
                                {this.state?.RewardTierProducts[0]?.TierTitle}
                              </h5>
                              <p>
                                {
                                  this.state?.selectedRewardDataToRedeem
                                    ?.PointsRequiredString
                                }
                              </p>
                            </>
                          )}
                          <div
                            style={{ marginTop: "2rem" }}
                            className="container"
                          >
                            {this.state?.RewardTierProducts &&
                              this.state?.RewardTierProducts?.map((each) => (
                                <div
                                  className="row reward-detail-wrapper"
                                  style={{
                                    border: "1px solid black",
                                    borderRadius: "10px",
                                    marginBottom: "1rem",
                                    alignItems: "center"
                                  }}
                                >
                                  <div className="col-4">
                                    <img
                                      src={each.ImageUrl}
                                      alt=""
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                      }}
                                    />
                                  </div>
                                  <div className="col-8 reward-detail">
                                    <p className="reward-price">{each.Title}</p>
                                    <p className="reward-upc">{each.UPC}</p>
                                    <p className="reward-point">
                                      {each.DeductPointsText}
                                    </p>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="modal-footer" style={{ padding: "0.7rem" }}>
                          <button
                            type="button"
                            className="btn btn-danger"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="entry-content">
                  <div className="woocommerce">
                    <div className="woocommerce-notices-wrapper" />
                    {this.state.myrewards ? (
                      this.state.myrewards.length > 0 ? (
                        <table className="table mt-5">
                          <tbody>
                            {this.state.myrewards.map((value, index) => {

                              return (
                                <tr key={index}>
                                  <td style={{ width: "25%", borderRight: 0 }}>
                                    <Link to="#">
                                      <div
                                        className="product-image"
                                        style={{
                                          textAlign: "left",
                                          marginTop: "36px",
                                        }}
                                      >
                                        <img
                                          alt="img"
                                          src={value.ImageUrl}
                                          style={{
                                            width: "50%",
                                            paddingLeft: 50,
                                          }}
                                        />
                                      </div>
                                    </Link>
                                  </td>
                                  <td className="reward-detail" style={{ padding: "35px" }}>
                                    <div
                                      className="product-title"
                                    >
                                      {value.Title}
                                      {value.IsPointsBased == true &&
                                        (
                                          <div className="product-title-value">
                                            {
                                              value.PointsBasedRewardPointsToDollarInfo
                                            }
                                          </div>
                                        )}
                                      {value.IsPointsBased == true ? (
                                        <span className="detail-btn">
                                          <button
                                            className={`btn-success btn btn-radius`}
                                            style={{
                                              marginTop: "2%",
                                              backgroundColor: "#B30838",
                                              color: "white",
                                            }}
                                            data-toggle="modal"
                                            data-target="#RewardDetailsShowModal"
                                            onClick={this.getNext}
                                          >
                                            Details
                                          </button>
                                          <br />
                                          <RewardDetailsModal
                                            value={value}
                                            reedemoptions={this.state?.reedemoptions}
                                          />
                                        </span>
                                      ) : (<span className="detail-btn">
                                        <button
                                          className={`btn-success btn btn-radius`}
                                          style={{
                                            marginTop: "2%",
                                            backgroundColor: "#B30838",
                                            color: "white",
                                          }}
                                          data-toggle="modal"
                                          data-target="#PunchRewardDetailsShowModal"
                                          onClick={() => this.openModal(value)}
                                        >
                                          View Details
                                        </button>
                                        <br />
                                        {this.state.modalOpen && this.state.modalOpenSelectedValue && (
                                          <PunchRewardDetailsModal
                                            value={this.state.modalOpenSelectedValue}
                                            reedemoptions={[]}
                                          />
                                        )}
                                      </span>)}
                                    </div>
                                    <ViewHistoryModal
                                      value={value}
                                      historyData={this.state?.historyData}
                                    />

                                    <div className="product-info-stock-sku">
                                      <div>
                                        {value.RewardTypeId === 1 ? (
                                          value.PurchasedQty >=
                                            value.BuyQtyAmount ? (
                                            <div style={{ textAlign: "left" }}>
                                              <p style={{ color: "red" }}>
                                                Congratulations! You earned a
                                                reward and it is on the way.
                                              </p>
                                              <p>
                                                Please allow 15-30 min before
                                                you see the reward in your
                                                list.It applies to your next
                                                purchase.
                                              </p>
                                            </div>
                                          ) : (
                                            this.Loopcount(
                                              value.BuyQtyAmount,
                                              value.PurchasedQty
                                            ).map((val, index) => (
                                              <div
                                                className="cirlce_points"
                                                key={index}
                                              >
                                                <i
                                                  className="fa fa-circle"
                                                  style={val}
                                                  aria-hidden="true"
                                                ></i>
                                              </div>
                                            ))
                                          )
                                        ) : (
                                          <>
                                            {value.IsPointsBased == true ? (
                                              // <ProgressBarnew
                                              //   percent={Math.round(
                                              //     ((PointsPerEachValue *
                                              //       value.PurchasedAmount) /
                                              //       value.MaxBarcodeValue) *
                                              //       100
                                              //   )}
                                              //   filledBackground="linear-gradient(to right, #58ae49, #58ae49)"
                                              // >
                                              //   {this.pointloop(
                                              //     value.MaxBarcodeValue,
                                              //     value.TierValue
                                              //   ).map((item, idx) => (
                                              //     <Step key={idx}>
                                              //       {({
                                              //         accomplished,
                                              //         index,
                                              //       }) => (
                                              //         <div
                                              //           className={`indexedStep ${
                                              //             accomplished
                                              //               ? "accomplished"
                                              //               : ""
                                              //           }`}
                                              //           style={{
                                              //             filter: `grayscale(0)`,
                                              //           }}
                                              //         >
                                              //           <img
                                              //             style={{
                                              //               filter: `grayscale(${
                                              //                 accomplished
                                              //                   ? 0
                                              //                   : 100
                                              //               }%)`,
                                              //               marginTop: "12px",
                                              //               height: "3opx",
                                              //             }}
                                              //             width="30"
                                              //             src="/assets/images/rewardFill.png"
                                              //           />

                                              //           <br />
                                              //           {Math.round(
                                              //             index *
                                              //               PointsPerEachValue
                                              //           ) == 0 ? (
                                              //             <>
                                              //               {Math.round(
                                              //                 index *
                                              //                   PointsPerEachValue
                                              //               )}
                                              //             </>
                                              //           ) : (
                                              //             <>
                                              //               {Math.round(
                                              //                 index *
                                              //                   PointsPerEachValue
                                              //               )}
                                              //               K
                                              //             </>
                                              //           )}
                                              //         </div>
                                              //       )}
                                              //     </Step>
                                              //   ))}
                                              // </ProgressBarnew>
                                              ""
                                            ) : value.RoundedPurchasedAmount >=
                                              value.BuyQtyAmount ? (
                                              <div
                                                style={{ textAlign: "left" }}
                                              >
                                                <p style={{ color: "red" }}>
                                                  Congratulations! You earned a
                                                  reward and it is on the way.
                                                </p>
                                                <p>
                                                  Please allow 15-30 min before
                                                  you see the reward in your
                                                  list.It applies to your next
                                                  purchase.
                                                </p>
                                              </div>
                                            ) : (
                                              <ProgressBar
                                                style={{ height: 25 }}
                                              >
                                                <ProgressBar
                                                  style={{ color: "black" }}
                                                  variant="warning"
                                                  label={Math.round(
                                                    `${value.PurchasedAmount}`
                                                  )}
                                                  now={
                                                    (value.PurchasedAmount /
                                                      value.BuyQtyAmount) *
                                                    100
                                                  }
                                                  key={2}
                                                />
                                              </ProgressBar>
                                            )}
                                          </>
                                        )}
                                        {value.IsPointsBased == true ? (
                                          <span
                                            className="left-coupons float-left"
                                            style={{
                                              textAlign: "left",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {value.PurchasedAmountString}
                                            {" - "}
                                            {value.RewardPurchasedAmountText}
                                          </span>
                                        ) : (
                                          <span
                                            className="left-coupons float-right"
                                            style={{ marginTop: "12px" }}
                                          >
                                            {value.BuyQtyAmount -
                                              value.PurchasedQty}{" "}
                                            Left
                                          </span>
                                        )}
                                      </div>
                                      <br></br>
                                      {value.IsPointsBased == true &&
                                        value?.IsItQualifiedforReward ? (
                                        CONFIG.DATA.ALLOW_POINT_BASE_REWARD_API ? (
                                          <div
                                            style={{
                                              marginTop: "2%",
                                              float: "right",
                                              textAlign: "right",
                                            }}
                                          >
                                            <button
                                              className={`btn-radius btn vc_btn3-style-custom`}
                                              style={{
                                                backgroundColor: "#B4083A",
                                                color: "#ffffff",
                                              }}
                                              onClick={this.getNext}
                                              type="button"
                                              data-toggle="modal"
                                              data-target="#redeemPointsModal"
                                            >
                                              Redeem Points
                                            </button>
                                          </div>
                                        ) : this.state.buttonVisible ? (
                                          <div
                                            style={{
                                              marginTop: "5%",
                                              width: "40%",
                                              float: "left",
                                              padding: "20px",
                                              marginLeft: "-28%",
                                            }}
                                          >
                                            <button
                                              className={`vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-custom`}
                                              style={{
                                                backgroundColor:
                                                  "rgb(69 169 73)",
                                                color: "#ffffff",
                                              }}
                                              onClick={this.getNext}
                                              type="button"
                                            >
                                              Redeem Points
                                            </button>
                                          </div>
                                        ) : null
                                      ) : (
                                        ""
                                      )}
                                      <h5 className="text-left eligible_label"></h5>
                                    </div>
                                    <div className="product-desc">
                                      <p
                                        style={{
                                          color: "red",
                                          fontWeight: "600"
                                        }}
                                      >
                                        {value?.NoOfPointsExpireString}
                                      </p>
                                      {value?.EnableShowPointsExpiryHistory && (
                                        <button
                                          className={`btn-success btn`}
                                          style={{
                                            backgroundColor: "#B30838",
                                            color: "white",
                                          }}
                                          data-toggle="modal"
                                          data-target="#ViewHistoryShowModal"
                                          onClick={this.getHistory}
                                        >
                                          View History
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div>
                          <div style={{ height: "100px" }}></div>
                          <h3>No Rewards found</h3>
                          <div style={{ height: "100px" }}></div>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Myrewards;
